export default __webpack_public_path__ + "static/media/1194.7cde1de9.png";